import { render, staticRenderFns } from "./OrdersInvoices.vue?vue&type=template&id=1d1f2c0c&"
import script from "./OrdersInvoices.vue?vue&type=script&lang=js&"
export * from "./OrdersInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports